export type CachedRequest<D> = () => Promise<D>;

export class PromiseCache<D> {
  private readonly cache = new Map<string, Promise<D>>();

  public has(cacheKey: string): boolean {
    return this.cache.has(cacheKey);
  }

  public get(cacheKey: string): Promise<D> | undefined {
    return this.cache.get(cacheKey);
  }

  public set(cacheKey: string, request: CachedRequest<D>): Promise<D> {
    const promise = new Promise<D>(async (resolve) => {
      const result = await request();

      resolve(result);
    }).finally(() => {
      this.cache.delete(cacheKey);
    });

    this.cache.set(cacheKey, promise);

    return promise;
  }
}
